/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AssignmentDetails } from './AssignmentDetails';
import type { DevicesBulkAssignmentTenantResponseDto } from './DevicesBulkAssignmentTenantResponseDto';
export type DevicesBulkAssignmentListResponseDto = {
  id: number;
  tenant: DevicesBulkAssignmentTenantResponseDto;
  status: DevicesBulkAssignmentListResponseDto.status;
  createdBy: string;
  createdAt: string;
  details: AssignmentDetails;
};
export namespace DevicesBulkAssignmentListResponseDto {
  export enum status {
    NEW = 'NEW',
    ENDED = 'ENDED',
    ERROR = 'ERROR',
  }
}

